export class CreateInsightsSessionDto {
 
  tenantId: string;
  productId: string;
  adminUser: boolean;
  powerUser: boolean;
  sourceUsername: string;
  sourceUserId: string;
 
}
